import { LoadMoreComponent } from '@components/LoadMoreComponent';
import {
  LoadMoreContext,
  LoadMoreCtx,
} from '@components/LoadMoreComponent/LoadMoreContext';
import { IDocumentTable } from '@models/Document.model';
import {
  documentsFieldNameDictionary,
  documentsSortDictionary,
} from '@models/DocumentTable.model';
import { FieldHeaderUpdatesAsset } from '@pages/Asset/components/Updates/Components/NewTable/FieldHeaderUpdatesAsset';

import { useQueryClient } from 'react-query';
import { StyledDiv, DocumentsTable } from './DocumentsBody.styles';
import { DocumentsBodyRawProps } from './DocumentsBody.types';
import { headings } from './DocumentsBody.utils';
import { getDocumentCell } from '../../logic/getDocumentCell';

export function DocumentsBodyRaw(props: DocumentsBodyRawProps) {
  const { query, pageFilter, filterFns } = props;
  const queryClient = useQueryClient();

  const { data, fetchNextPage, hasNextPage = false } = query;
  const allData = data.pages.reduce((page, next) => {
    return page.concat(next.results);
  }, [] as IDocumentTable[]);

  const loadMoreCtx: LoadMoreCtx = {
    fetchNextPage,
    hasNextPage,
  };

  return (
    <StyledDiv className="bscroll">
      <DocumentsTable>
        <thead>
          <tr>
            {headings.map(heading => {
              const label = documentsFieldNameDictionary[heading.fieldName];
              const sortString = documentsSortDictionary[heading.fieldName];
              const isSorted = pageFilter.sort.sort === sortString;
              const { fieldName } = heading;
              return (
                <th key={heading.fieldName} data-fieldname={fieldName}>
                  <FieldHeaderUpdatesAsset
                    label={label}
                    currentSort={pageFilter.sort.sort}
                    sortString={sortString}
                    onSort={() => {
                      filterFns.sortBy(sortString, !isSorted);
                    }}
                    direction={pageFilter.sort.direction}
                  />
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {allData.map(document => {
            return (
              <DocumentsTable.Tr
                key={document.id}
                cells={headings.map((heading, index, array) => {
                  const isLast = index === array.length - 1;
                  return {
                    id: heading.fieldName,
                    node: getDocumentCell({
                      heading,
                      document,
                      isLast,
                      queryClient,
                    }),
                  };
                })}
              />
            );
          })}
        </tbody>
      </DocumentsTable>
      <LoadMoreContext.Provider value={loadMoreCtx}>
        <LoadMoreComponent />
      </LoadMoreContext.Provider>
    </StyledDiv>
  );
}
